document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.prod_card_slider_main').forEach(function(collcard) {
    const swiperEl = collcard.querySelector('.prod_card_slider_swiper');
    if (!swiperEl) return;
    const prevBtn = collcard.querySelector('.prod_card_slider_swiper_button_prev');
    const nextBtn = collcard.querySelector('.prod_card_slider_swiper_button_next');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
            checkScrollable(this);
        },
        resize: function () {
            checkScrollable(this);
        },
     },
    });

    function checkScrollable(swiperInstance) {
        const mainwrapp = collcard.querySelector('.prod_card_slider_content');
        const wrapper = swiperInstance.wrapperEl;
        const container = swiperInstance.el;

        if (wrapper.scrollWidth > container.clientWidth) {
            mainwrapp.classList.add("prod_card_slider_scrollable");
            mainwrapp.classList.remove("prod_card_slider_not_scrollable");
        } else {
            mainwrapp.classList.remove("prod_card_slider_scrollable");
            mainwrapp.classList.add("prod_card_slider_not_scrollable");
        }
    }

  });
});